<template>
  <div class="container is-max-desktop px-6">
    <div v-if="!isProcessingPayment && isDisplayTypesPayments" class="types-payments">
      <h1 class="subtitle is-4">Selecione o tipo de pagamento</h1>
      <div class="buttons">
       <b-button 
        type="is-primary" 
        expanded
        @click="handleCredit"
      >
        CRÉDITO
      </b-button>
     <b-button 
        type="is-primary" 
        expanded
        @click="handleDebit"
      >
        DÉBITO
      </b-button>
     <b-button
        tag="router-link"
        to="/invoice"
        type="is-primary" 
        expanded
      >
        VOLTAR
      </b-button>
     </div>
    </div>
    <div v-else-if="isProcessingPayment" class="processingPayment">
      <h1 class="subtitle is-4">Processando pagamento...</h1>
      <h1 class="subtitle is-6">Siga as intruções da maquineta</h1>
    </div>
    <div v-else>
      <div v-if="isSuccessPayment">
         <h1 class="subtitle is-4">PAGAMENTO REALIZADO</h1>
          <div class="buttons">
            <b-button 
              type="is-primary" 
              expanded
              @click="handleSendProofEmail"
            >
              ENVIAR COMPROVANTE POR E-MAIL
            </b-button>
          <b-button 
              type="is-primary" 
              expanded
              @click="handlePrintBoleto"
            >
              IMPRIMIR COMPROVANTE
            </b-button>
          <b-button
              tag="router-link"
              to="/userstar"
              type="is-primary" 
              expanded
            >
              FINALIZAR
            </b-button>
       </div>
      </div>
      <div v-else>
        <h1 class="subtitle is-4">PAGAMENTO FALHO</h1>
        <h1 class="subtitle is-6">Não conseguimos realizar</h1>
        <div class="buttons">
          <b-button 
            type="is-primary" 
            expanded
            @click="isDisplayTypesPayments = true"
            >
            TENTAR NOVAMENTE
          </b-button>
          <b-button
            tag="router-link"
            to='/userstar' 
            type="is-primary" 
            expanded
            @click="handlePrintBoleto"
            >
            CANCELAR
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    invoices: Array
  },
  data () {
    return {
      isDisplayTypesPayments: true,
      isProcessingPayment: false,
      isSuccessPayment: false,
    }
  },
  methods: {
    totalInvoices () {
      const total = this.invoices.reduce((acumulador, valor)=> {
        return acumulador += valor.total
      },0)
      console.log(total)
    },
    handleCredit() {
      this.totalInvoices()

      this.isDisplayTypesPayments = false,

      this.isProcessingPayment = true

      setTimeout(() => {
      this.isProcessingPayment = false
      this.isSuccessPayment = true
      }, 10000);
    },
    handleDebit() {
      this.totalInvoices()

      this.isDisplayTypesPayments = false,

      this.isProcessingPayment = true

      setTimeout(() => {
      this.isProcessingPayment = false
      this.isSuccessPayment = false
      }, 10000);
    },
    handleSendProofEmail() {
      // TODO get the receipt

      // TODO pass receipt through params
      // this.$router.push({name: 'EmailSending', params: {proof: proof}})
      this.$router.push({name: 'EmailSending'})
    },
    handlePrintBoleto () {
      if (this.invoices.length) {
        this.$router.push({
          name: "PrintBoleto",
          params: { invoices: this.invoices },
        });
      }
    },
  }
}
</script>

<style>

</style>